import React, { useState, useEffect } from "react";
import { Search, FileText } from "lucide-react";
import "../Consolidate_Collection_Summary_Report/ConsolidateCollectionReport.css";
import { FaFilter, FaUser } from "react-icons/fa";
import { userServicer } from "../../Commen_Services/user.services";
import { Chip, FormControl, InputLabel, MenuItem, Select, Stack, TextField } from "@mui/material";
import LastPageIcon from '@mui/icons-material/LastPage';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { GrPowerReset } from "react-icons/gr";
import { IoClose } from "react-icons/io5";
import Popup from "reactjs-popup";
import { RoleRightMasterService } from "../../Commen_Services/RoleRightMaster.service";
import { AccessLevel, InputType, PageEnums } from "../../../_enums/enum.services";
import ExportToCSV from "../../Commen_Component/Export/ExportToCSV";
import { commanServicer } from "../../Commen_Services/common.services";

interface ColumnData {
    tableFieldName: string;
    headerName: string;
    subReportKeyField: string;
    showFieldDDL: boolean;
    fieldType: Number;
    isDisplay: boolean;
    isExport: boolean;

}

interface FilterChip {
    key: string;
    label: string;
    value: string;
    removable: boolean;
}

interface SortConfig {
    field: string;
    direction: 'asc' | 'desc';
}

interface SearchCriteria {
    id: string;
    field: string;
    value: string;
}

interface TransactionReport {
    subReportName: string;
    collectionDate: string;
    paymentMode: string;
    collectedAmount: string;
    details: any[];
}


export default function EasebuzzTransactionReport() {
    const [data, setData] = useState<any[]>([]);
    const [columnData, setColumnData] = useState<ColumnData[]>([]);
    const [reportConfigData, setreportConfigData] = useState<any>([]);
    const [isDefaultSearch, setIsDefaultSearch] = useState<boolean>(false);
    const [viewButtonSum, setButtonSum] = useState<number[]>([]);
    const [tableLoading, setTableLoading] = useState(true);
    const [loadingProgress, setLoadingProgress] = useState(0);
    const [showFilterPopup, setShowFilterPopup] = useState(false);
    const [searchField, setSearchField] = useState("");
    const [searchTerm, setSearchTerm] = useState<Record<string, string>>({});
    const [sortConfig, setSortConfig] = useState<SortConfig | null>(null);
    const [searchCriteria, setSearchCriteria] = useState<SearchCriteria[]>([]);
    const [dynamicFilterValues, setDynamicFilterValues] = useState<Record<string, string>>({});
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [previousFrom, setPreviousFrom] = useState(dateFrom);
    const [previousTo, setPreviousTo] = useState(dateTo);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [exportColumns, setExportColumns] = React.useState<ColumnData[]>(columnData);
    const [activeFilters, setActiveFilters] = useState<FilterChip[]>([
        {
            key: "dateOfTransaction_from",
            label: "Collection Date From",
            value: dateFrom,
            removable: false
        },
        {
            key: "dateOfTransaction_to",
            label: "Collection Date To",
            value: dateTo,
            removable: false
        }
    ]);
    const [apiPayload, setAPIPayload] = useState<{ key: string; value: string }[]>([]);

    useEffect(() => {
        fecthReportData();    
    }, []);

    const fecthReportData = async () => {
        try {
            const [tableConfig, reportConfig, roleRightAccessSum] = await Promise.all([
                userServicer.tableConfig(PageEnums.EasebuzzTransactionReport),
                userServicer.reportConfig(PageEnums.EasebuzzTransactionReport),
                RoleRightMasterService.getRoleRigthAccessSum(PageEnums.EasebuzzTransactionReport)
            ]);
            const exportColumnData = tableConfig?.data?.filter((item: any) => item.isExport === true);
            setColumnData(tableConfig.data);
            setreportConfigData(reportConfig.data);
            setButtonSum(findSumElements(roleRightAccessSum.data[0].accessLevel));
            setExportColumns(exportColumnData);
            let def = reportConfig.data.defaultSearchList;
            if (def?.length > 0) {
                def.forEach((element: any) => {
                    if (element.hasFromToDateField == 1) {
                        if (element.defaultSearchFieldValue != null && element.defaultSearchFieldValue != undefined) {
                            const currentDate = new Date(element.defaultSearchFieldValue);
                            currentDate.setDate(currentDate.getDate() + element.defDateDurationInDays);
                            const nextDate = currentDate.toISOString().split('T')[0];
                            const today = new Date().toISOString().split('T')[0];
                            setDateFrom(element.defaultSearchFieldValue);
                            setDateTo(nextDate > today ? today : nextDate);
                            setPreviousFrom(element.defaultSearchFieldValue);
                            setPreviousTo(nextDate > today ? today : nextDate);
                            setActiveFilters([
                                { key: "dateOfTransaction_from", label: "Collection Date From", value: element.defaultSearchFieldValue, removable: false },
                                { key: "dateOfTransaction_to", label: "Collection Date To", value: nextDate > today ? today : nextDate, removable: false }
                            ]);
                            

                            setAPIPayload([
                                { key: "dateOfTransaction_from", value: element.defaultSearchFieldValue },
                                { key: "dateOfTransaction_to", value: nextDate > today ? today : nextDate }
                            ]);

                        } else {
                            const toDate = new Date().toISOString().split('T')[0];
                            const lastDate = new Date(toDate);
                            lastDate.setDate(lastDate.getDate() - element.defDateDurationInDays);
                            const fromDate = lastDate.toISOString().split('T')[0];
                            setDateFrom(fromDate);
                            setDateTo(toDate);
                            setPreviousFrom(fromDate);
                            setPreviousTo(toDate);
                            setActiveFilters([
                                { key: "dateOfTransaction_from", label: "Collection Date From", value: fromDate, removable: false },
                                { key: "dateOfTransaction_to", label: "Collection Date To", value: toDate, removable: false }
                            ]);

                            setAPIPayload([
                                { key: "dateOfTransaction_from", value: fromDate },
                                { key: "dateOfTransaction_to", value: toDate }
                            ]);
                        }
                    }
                });
                setIsDefaultSearch(true);
            }
            else {

            }
        }
        catch (ex) {

        }
    }

    const findSumElements = (target: number): number[] => {
        //const arr = [1, 2, 4, 8, 16, 32, 64, 128];
        const arr = Object.values(AccessLevel);
        let result: number[] = [];
        let n = arr.length;

        // Use a variable to keep track of whether a valid subset is found
        let found = false;

        // Loop through all possible subsets using bitmasking
        for (let i = 0; i < (1 << n); i++) {
            let sum = 0;
            let subset: number[] = [];

            for (let j = 0; j < n; j++) {
                if (i & (1 << j)) {
                    sum += arr[j];
                    subset.push(arr[j]);
                }
            }

            // Check if the current subset sums up to the target
            if (sum === target) {
                // Update result only if a subset is found
                result = subset;
                found = true;
                break;  // Exit the loop once a valid subset is found
            }
        }

        // Return the result if found, otherwise an empty array
        return found ? result : [];
    };

    const fetchData = async (resetFilters = false, isExport = false) => {
        setTableLoading(true);
        if (dateFrom != "" && dateTo != "" && apiPayload.length > 0) {
            try {
                setLoadingProgress(0);
                const customFilter = [
                    {
                        key: "dateOfTransaction_from",
                        label: "Collection Date From",
                        value: dateFrom,
                        removable: false
                    },
                    {
                        key: "dateOfTransaction_to",
                        label: "Collection Date To",
                        value: dateTo,
                        removable: false
                    }
                ];
                if (resetFilters) {
                    setSearchCriteria([]);
                    setSearchField("");
                    setCurrentPage(1);
                    setSortConfig(null);
                    setActiveFilters(customFilter);
                }
                const progressSteps = [10, 25, 45, 60, 75, 85, 95];
                let i = 0;
                const progressInterval = setInterval(() => {
                    if (i < progressSteps.length) {
                        setLoadingProgress(progressSteps[i]);
                        i++;
                    }
                }, 200);
                const paginationData = {
                    pageNumber: currentPage,
                    pageSize: rowsPerPage,
                    isExport: isExport
                }
                const { controller: newController, data: tableData } = await userServicer.getEasebuzzTransactionReport(PageEnums.EasebuzzTransactionReport, apiPayload, paginationData);
                if (tableData) {
                    clearInterval(progressInterval);
                    setLoadingProgress(100);
                    setData(tableData.data);
                }
            } catch (ex) {
                console.error("Failed to fetch data", ex);
            } finally {
                setTimeout(() => {
                    setTableLoading(false);
                    setLoadingProgress(0);
                }, 300);
            }
        }
    };

    const onBeforeExport = async (): Promise<any[]> => {
        try {
            const paginationData = {
                        pageNumber: currentPage,
                        pageSize: rowsPerPage,
                        isExport: true
                    }
            const { controller: newController, data: tableData } = await userServicer.getEasebuzzTransactionReport(PageEnums.EasebuzzTransactionReport, apiPayload, paginationData);
                    

            return tableData?.data || [];
        } catch (error) {
            console.error("Failed to fetch all data for export", error);
            return [];
        }
    };


    

    useEffect(() => {
        fetchData();
    },[isDefaultSearch,currentPage,rowsPerPage,apiPayload])

    useEffect(() => {
        const values = searchCriteria.reduce<Record<string, string>>((acc, item) => {
            acc[item.field] = item.value;
            return acc;
        }, {});
        setDynamicFilterValues(values);
    }, [searchCriteria]);

    const totalPages = Math.ceil(data.length > 0 ? data[0].totalRecord / rowsPerPage : 0);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm, searchField]);

    const handleApplyFilters = () => {
        const newFilters: FilterChip[] = [
            {
                key: "dateOfTransaction_from",
                label: "Collection Date From",
                value: dateFrom,
                removable: false
            },
            {
                key: "dateOfTransaction_to",
                label: "Collection Date To",
                value: dateTo,
                removable: false
            }
        ];

        const newData: FilterChip[] = Object.entries(dynamicFilterValues).reduce(
            (acc: FilterChip[], [field, value]) => {
                if (value !== "" && value !== null && value !== undefined) {
                    const label =
                        columnData.find((col) => col.tableFieldName === field)?.headerName || field;
                    acc.push({
                        key: field,
                        label,
                        value,
                        removable: true,
                    });
                }
                return acc;
            },
            []
        );
        

        newFilters.push(...newData);
        setActiveFilters(newFilters);
        setAPIPayload(newFilters);

        const isDifferent =
            Object.keys(dynamicFilterValues).some(
                key => searchTerm[key] !== dynamicFilterValues[key]
            ) ||
            Object.keys(searchTerm).some(
                key => !(key in dynamicFilterValues)
            );

        if (isDifferent) {
            setSearchTerm(dynamicFilterValues);
        }

        const newSearchCriteria: SearchCriteria[] = Object.entries(dynamicFilterValues).map(
            ([field, value]) => ({
                id: `${field}`,
                field,
                value
            })
        );
        const hasChanges = newSearchCriteria.length !== searchCriteria.length ||
            newSearchCriteria.some((item, index) =>
                item.field !== searchCriteria[index]?.field ||
                item.value !== searchCriteria[index]?.value
            );
        if (hasChanges) {
            setSearchCriteria(newSearchCriteria);
        }
        setShowFilterPopup(false);
    };

    const removeFilter = (filterId: string) => {
        setActiveFilters(prev => {
            const updated = prev.filter(filter => filter.key !== filterId);
            return updated;
        });

        setAPIPayload(prev => {
            const updated = prev.filter(filter => filter.key !== filterId);
            return updated;
        });

        setSearchCriteria(prev => {
            const updated = prev.filter(criteria => criteria.id !== filterId);
            return updated;
        });
        setSearchTerm(prev => {
            const updated = { ...prev };
            delete updated[filterId];
            return updated;
        });

        if (filterId === "search") {
            setSearchField("");
        }
    };

    const handleSort = (fieldName: string) => {
        let direction: 'asc' | 'desc' = 'asc';
        if (sortConfig && sortConfig.field === fieldName && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ field: fieldName, direction });
    };

    const addSearchCriteria = (value: string | null | undefined) => {
       
        if (!searchField) return;
        const isEmpty = value === "" || value === null || value === undefined;
        setData([]);
        setSearchCriteria(prevCriteria => {
            let updatedCriteria: SearchCriteria[];

            if (isEmpty) {
                // Remove the search field from criteria
                updatedCriteria = prevCriteria.filter(
                    criteria => criteria.field !== searchField
                );
            } else {
                const existingIndex = prevCriteria.findIndex(
                    criteria => criteria.field === searchField
                );

                if (existingIndex !== -1) {
                    updatedCriteria = [...prevCriteria];
                    updatedCriteria[existingIndex] = {
                        ...updatedCriteria[existingIndex],
                        value: value
                    };
                } else {
                    const newCriteria: SearchCriteria = {
                        id: searchField,
                        field: searchField,
                        value: value
                    };
                    updatedCriteria = [...prevCriteria, newCriteria];
                }
            }

            // Update active filters
            setActiveFilters(prevFilters => {
                const fieldLabel = searchField === "" ? "Global Search" :
                    columnData.find(col => col.tableFieldName === searchField)?.headerName || searchField;
                
                const fieldKey = searchField === "" ? "Global Search" :
                    columnData.find(col => col.tableFieldName === searchField)?.tableFieldName || searchField;

                if (isEmpty) {
                    setAPIPayload(prevAPIPayload => (prevAPIPayload.filter(filter => filter.key !== fieldKey)));
                    return prevFilters.filter(filter => filter.label !== fieldLabel);

                }

                const existingFilterIndex = prevFilters.findIndex(filter =>
                    filter.label === fieldLabel
                );

                const newFilter: FilterChip = {
                    key: searchField,
                    label: fieldLabel,
                    value: value,
                    removable: true
                };

                let updatedFilters: FilterChip[];

                if (existingFilterIndex !== -1) {
                    updatedFilters = [...prevFilters];
                    updatedFilters[existingFilterIndex] = newFilter;
                } else {
                    updatedFilters = [...prevFilters, newFilter];
                }
                setAPIPayload(updatedFilters);

                return updatedFilters;

                
            });

            return updatedCriteria;
        });
    };

    const handleDynamicFilterChange = (fieldName: string, value: string) => {
        setDynamicFilterValues(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };

    const resetDynamicFilters = () => {
        setDynamicFilterValues({});
        setDateFrom(previousFrom);
        setDateTo(previousTo);
    };


    return (
        <div>
            <div className="shadow">
                <div className="bg-line">
                    <span className="bg-head"><FaUser /> &nbsp;{reportConfigData.reportName}
                    </span>
                </div>
                <hr className="colorgraph" />
            </div>

            <div className="mani">
                <div style={{ width: '100%' }}>
                    <div>
                        <form onSubmit={(e) => e.preventDefault()}>
                            <div className="popup_filter1" >
                                <div className="popup_filter2">
                                    <FormControl variant="standard">
                                        <InputLabel id="demo-simple-select-standard-label" sx={{
                                            fontSize: '12px', color: 'var(--body-main-dark-color)', borderColor: 'var(--body-main-dark-color)',
                                        }}> Search Field </InputLabel>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            value={searchField}
                                            onChange={(e) => setSearchField(e.target.value)}
                                            label="Search Field"
                                            MenuProps={{
                                                PaperProps: {
                                                    style: {
                                                        maxHeight: 140,
                                                        overflowY: 'auto',
                                                    },
                                                },
                                            }}
                                        >
                                            {columnData.filter(column => column.showFieldDDL && column.fieldType != InputType.Date).map((option, i) => (
                                                option.fieldType != InputType.Date && <MenuItem key={i} value={option.tableFieldName}>{option.headerName}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <div style={{ marginTop: '3px' }}>
                                        {
                                            <FormControl variant="standard">
                                                <TextField
                                                    variant="standard"
                                                    value={searchTerm[searchField] || ""}
                                                    label="search"
                                                    onChange={(e) => { setSearchTerm((prev) => ({ ...prev, [searchField]: e.target.value })); addSearchCriteria(e.target.value) }}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: 'var(--body-main-dark-color)',
                                                            fontSize: '12px',
                                                            borderColor: 'red',
                                                        },
                                                    }}
                                                    InputProps={{
                                                        style: {
                                                            width: '200px',
                                                        }
                                                    }}
                                                />
                                            </FormControl>
                                        }

                                    </div>
                                    <div className="center-pop">
                                        {
                                            viewButtonSum.map((item: any, btnIndex) => (
                                                <React.Fragment key={`${btnIndex}-${'btn'}`}>
                                                    {item === AccessLevel.Filter && (<button key={`${btnIndex}`} className="btn12" onClick={() => setShowFilterPopup(true)}><FaFilter /></button>)}
                                                    {item === AccessLevel.Export && (<ExportToCSV csvData={data} headerName={exportColumns} fileName={reportConfigData?.exportReportName} pageID={"27"} filterFieldData={[]} TotalRecord={0} isStatic={true} onBeforeExport={onBeforeExport} />)}
                                                </React.Fragment>
                                            ))

                                        }
                                    </div>
                                </div>
                                <div className="chips-container">
                                    <Stack
                                        spacing={{ xs: 1, sm: 1 }}
                                        direction="row"
                                        useFlexGap
                                        sx={{ flexWrap: 'wrap' }}
                                        alignItems="flex-end"
                                        justifyContent="flex-end"
                                    >
                                        {activeFilters.map((filter) => (
                                            <Chip
                                                key={filter.key}
                                                label={`${filter.label} : ${filter.value}`}
                                                variant="outlined"
                                                onDelete={filter.removable ? () => removeFilter(filter.key) : undefined}
                                                sx={{
                                                    backgroundColor: 'var(--filter-chips-color)',
                                                    border: '1px solid var(--body-main-dark-color)',
                                                    color: 'var(--body-main-dark-color)',
                                                    fontWeight: 500,
                                                    width: 'fit-content',
                                                }}
                                            />
                                        ))}
                                    </Stack>

                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="card-container">
                <div className="collection-wrapper">
                    <div className="collection-table-card">
                        <div className="collection-table-wrapper">
                            <table className="collection-table">
                                <thead className="collection-table-header">
                                    <tr className="collection-table-header-row">
                                        {columnData.filter(item => item.isDisplay).map((column) => (
                                            <th
                                                key={column.tableFieldName}
                                                className="collection-table-header-cell"
                                                onClick={() => handleSort(column.tableFieldName)}
                                                style={{
                                                    cursor: 'pointer',
                                                    userSelect: 'none',
                                                    position: 'relative',
                                                    paddingRight: '2rem'
                                                }}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <span>{column.headerName}</span>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        marginLeft: '0.5rem',
                                                        fontSize: '0.75rem',
                                                        lineHeight: '1'
                                                    }}>
                                                        <span style={{
                                                            color: sortConfig?.field === column.tableFieldName && sortConfig?.direction === 'asc'
                                                                ? 'var(--body-main-dark-color)' : 'rgba(255, 255, 255, 0.5)',
                                                            fontSize: '0.525rem'
                                                        }}>▲</span>
                                                        <span style={{
                                                            color: sortConfig?.field === column.tableFieldName && sortConfig?.direction === 'desc'
                                                                ? 'var(--body-main-dark-color)' : 'rgba(255, 255, 255, 0.5)',
                                                            fontSize: '0.525rem'
                                                        }}>▼</span>
                                                    </div>
                                                </div>
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="collection-table-body">
                                    {(tableLoading  ) ? (
                                        <tr>
                                            <td
                                                colSpan={columnData.length}
                                                className="collection-loading-container"
                                            >
                                                <div className="collection-loading-content">
                                                    <div className="collection-loading-spinner">
                                                        <div className="collection-loading-spinner-inner">
                                                            <FileText />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <h3 className="collection-loading-title">Loading Table Data</h3>
                                                        <p className="collection-loading-text">Processing hard report data...</p>
                                                        <div className="collection-progress-bar">
                                                            <div
                                                                className="collection-progress-fill"
                                                                style={{ width: `${loadingProgress}%` }}
                                                            ></div>
                                                        </div>
                                                        <p className="collection-progress-text">{loadingProgress}%</p>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : data.map((row, index) => (
                                        <tr
                                            key={`${row.id}_${index}`}
                                            className="collection-table-row"
                                            style={{ animationDelay: `${index * 50}ms` }}
                                        >
                                            {columnData.filter(item => item.isDisplay).map((column, subIndex) => (
                                                <td
                                                    key={`${column.tableFieldName}_${index}_${subIndex}`}
                                                    className="collection-table-cell"
                                                >
                                                    { column.fieldType === InputType.Date ? (commanServicer.formatToCustomDateTime(row[column.tableFieldName], false)) : (
                                                        row[column.tableFieldName]
                                                    )}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                    {!tableLoading && data.length === 0 && apiPayload.length > 0 &&    (
                                        <tr>
                                            <td
                                                colSpan={columnData.length}
                                                className="collection-empty-state"
                                            >
                                                <div className="collection-empty-content">
                                                    <Search />
                                                    <p className="collection-empty-title">No results found</p>
                                                    <p className="collection-empty-text">Try adjusting your search criteria</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        <div className="collection-pagination">
                            <div className="collection-pagination-content">
                                <div className="collection-pagination-left">
                                    <span className="collection-pagination-text">Rows per page:</span>
                                    <FormControl variant="standard" sx={{ m: 1, border: 'none' }}>
                                        <Select
                                            labelId="demo-simple-select-standard-label"
                                            id="demo-simple-select-standard"
                                            value={rowsPerPage}
                                            onChange={(e) => {
                                                setRowsPerPage(Number(e.target.value));
                                                setCurrentPage(1);
                                            }}
                                            disableUnderline
                                            sx={{
                                                border: 'none'
                                            }}
                                        >
                                            <MenuItem value={5}>5</MenuItem>
                                            <MenuItem value={10}>10</MenuItem>
                                            <MenuItem value={25}>25</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <span className="collection-pagination-text">
                                        {data.length === 0 ? "0" : startIndex + 1}-{Math.min(endIndex, data.length === 0 ? "0" : data[0].totalRecord)} of {data.length === 0 ? "0" : data[0].totalRecord}
                                    </span>
                                </div>

                                <div className="collection-pagination-right">
                                    <button
                                        onClick={() => setCurrentPage(1)}
                                        disabled={currentPage === 1}
                                        className="collection-pagination-btn"
                                    >
                                        <FirstPageIcon />
                                    </button>
                                    <button
                                        onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                                        disabled={currentPage === 1}
                                        className="collection-pagination-nav-btn"
                                    >
                                        <KeyboardArrowLeft />
                                    </button>
                                    <button
                                        onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                                        disabled={currentPage === totalPages || totalPages === 0}
                                        className="collection-pagination-nav-btn"
                                    >
                                        <KeyboardArrowRight />
                                    </button>
                                    <button
                                        onClick={() => setCurrentPage(totalPages)}
                                        disabled={currentPage === totalPages || totalPages === 0}
                                        className="collection-pagination-btn"
                                    >
                                        <LastPageIcon />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showFilterPopup && (
                        <Popup contentStyle={{ height: 250, width: 450, padding: 0 }} open={showFilterPopup} onClose={() => setShowFilterPopup(false)}>
                            <div className="pop-main">
                                <div className="pop-head"><span className="pop-form">&nbsp;<FaFilter />&nbsp;&nbsp;Consolidate Collection Summary Filter</span></div>
                                <div className="pop-form">
                                    <div className="grid-container">
                                        {columnData
                                            .filter(column => column.showFieldDDL)
                                            .map((column) => (
                                                <>
                                                    {column.fieldType === InputType.Date ? (
                                                        <>
                                                            <TextField
                                                                sx={{ marginRight: 1 }}
                                                                id="standard-basic"
                                                                variant="standard"
                                                                name={column.tableFieldName + "_from"}
                                                                type="date"
                                                                value={dateFrom}
                                                                label={column.headerName + " From "}
                                                                onChange={(e) => { setDateFrom(e.target.value) }}
                                                                InputProps={{
                                                                    inputProps: {
                                                                        className: dateFrom ? '' : 'custom-date-input',
                                                                        max: "9999-12-31",
                                                                    },
                                                                    style: {
                                                                        color: dateFrom ? 'var(--body-main-dark-color)' : 'black',
                                                                        fontSize: '14px',
                                                                        width: '200px',

                                                                    },
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        color: 'var(--body-main-dark-color)',
                                                                        fontSize: '12px',
                                                                    },

                                                                }}
                                                                FormHelperTextProps={{
                                                                    style: {
                                                                        maxWidth: '210px'
                                                                    },
                                                                }}

                                                            />
                                                            <TextField
                                                                sx={{ marginRight: 1 }}
                                                                id="standard-basic"
                                                                variant="standard"
                                                                name={column.tableFieldName + "_to"}
                                                                type="date"
                                                                value={dateTo}
                                                                label={column.headerName + " To "}
                                                                onChange={(e) => {setDateTo(e.target.value) }}
                                                                InputProps={{
                                                                    inputProps: {
                                                                        className: dateTo ? '' : 'custom-date-input',
                                                                        max: "2030-12-31",
                                                                    },
                                                                    style: {
                                                                        color: dateTo ? 'var(--body-main-dark-color)' : 'black',
                                                                        fontSize: '14px',
                                                                        width: '200px',
                                                                    },
                                                                }}
                                                                InputLabelProps={{
                                                                    style: {
                                                                        color: 'var(--body-main-dark-color)',
                                                                        fontSize: '12px',
                                                                    },

                                                                }}
                                                                FormHelperTextProps={{
                                                                    style: {
                                                                        maxWidth: '210px'

                                                                    },
                                                                }}
                                                            />
                                                        </>
                                                    ) : (
                                                        <div>
                                                            <TextField id="standard-basic" key={`${column.tableFieldName}-${column.headerName}`} variant="standard" name={column.tableFieldName} value={dynamicFilterValues[column.tableFieldName] || ''} label={column.headerName}
                                                                onChange={(e) => handleDynamicFilterChange(column.tableFieldName, e.target.value)}

                                                                InputProps={{
                                                                    style: {
                                                                        color: 'var(--body-main-dark-color)',
                                                                        fontSize: '14px',
                                                                        width: '200px',
                                                                        borderColor: 'red'
                                                                    }

                                                                }}

                                                                InputLabelProps={{
                                                                    style: {
                                                                        color: 'var(--body-main-dark-color)',
                                                                        fontSize: '12px',
                                                                        borderColor: 'red',

                                                                    },
                                                                }}

                                                            />
                                                        </div>
                                                    )}
                                                </>
                                            ))}
                                    </div>
                                    <div className='btns'>
                                        <div>
                                            <button className='btn1' onClick={resetDynamicFilters} ><span><GrPowerReset /></span>Reset</button>
                                        </div>
                                        <div>
                                            <button className='btn1' onClick={handleApplyFilters}><span><FaFilter /></span> Filter</button>&nbsp;
                                            <button className='btn1' onClick={() => setShowFilterPopup(false)} ><span><IoClose /></span>Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Popup>
                    )
                }
            </div>
        </div>
    );
}

